import axios from 'axios';
import { attachCsrfInterceptor } from './csrf';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/', // Example: http://127.0.0.1:8000/
  withCredentials: true, // MOST IMPORTANT PART
});

attachCsrfInterceptor(instance);

export default instance;
